<mat-toolbar color="primary">
  <span id="beslutning-rediger-dialog-tittel">
    @if (beslutning.erForslag) {
      {{ "Rediger forslag til beslutning"|translate }}
    } @else {
      {{ "Rediger beslutning"|translate }}
    }
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

<form [formGroup]="skjema" (ngSubmit)="lagre()">
  <mat-dialog-content class="skjema">
    <beslutning-skjema [skjema]="skjema" [gruppeId]="beslutning.eiendeGruppeId"/>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
    <button mat-raised-button color="primary" type="submit" cdkFocusInitial
            [disabled]="skjema.invalid || lagrer()" [visSpinner]="lagrer()"
            spinnerTekst="{{'Lagrer...'|translate}}" data-testid="lagre">
      {{ 'Lagre'|translate }}
    </button>
  </mat-dialog-actions>
</form>

